import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
});

export const getToken = () => {
  const store = JSON.parse(window.localStorage.getItem("readycash-report"));
  const token = store.user.user.bearer_token;
  return token;
};

export const getDefaultState = () => {
  return {
    error: null,
    success: null,
    status: null,
    loading: false,
    initialLoad: false,
    token: null,
    user: {},
    delay: 100,
    options: {
      duration: 2,
      useEasing: true,
      useGrouping: true,
      separator: ",",
      decimal: ".",
      prefix: "",
      suffix: "",
    },
    emptyImg:
      "<img src=" +
      require("@/assets/icons/no-result.svg") +
      "><br> <p>No search result</p>",
    errorMessages: {
      required: "Password is required",
      minLength: "At least 8 characters long",
      upperCaseCheck: "At least 1 uppercase letter",
      numberCheck: "At least 1 number",
      specialCharCheck: "At least 1 special character",
    },
  };
};

export const resetState = () => {
  window.localStorage.removeItem("readycash-report");
  router.go({ path: "/login" });
  localStorage.setItem("expired", "true");
};
